<script lang="ts" setup>
defineProps<{
  pages: any
}>()

const localeRoute = useLocaleRoute()
const { t } = useI18n()
</script>

<template>
  <ClientOnly>
    <UCarousel
      v-slot="{ item }"
      dots
      :items="pages"
      :ui="{
        container: 'm-auto ps-0',
        item: 'basis-auto max-w-75 min-[400px]:max-w-95 w-full last:mr-4',
        dot: `
              w-4 h-4
              rounded-full
              bg-[#1d1d1d]
              border-4 border-transparent
              data-[state=active]:bg-[#6827ff]
              data-[state=active]:border-[#1d1d1d]
              box-border`,
      }"
    >
      <NuxtLink
        :to="localeRoute('/blog/' + item.slug)"
        class="bg-gray-500 rounded-lg flex"
      >
        <div class="flex flex-col">
          <NuxtImg
            loading="lazy"
            :alt="item.title"
            class="rounded-t-lg h-49.75 w-full object-cover"
            :src="item.image.url || ''"
          />
          <div
            class="rounded-b-lg px-4.5 pt-7 pb-3.5 h-64 flex flex-col justify-between items-start"
          >
            <div>
              <div class="flex flex-row items-center">
                <img
                  :alt="item.updatedAt"
                  src="~/assets/images/nft-tickets/event-date.svg"
                  class="w-4 h-4"
                />
                <span
                  class="ml-1 text-xs font-medium tracking-wide text-[#A3A3A3]"
                >
                  {{ $dayjs(item.updatedAt).format('LL') }}
                </span>
              </div>
              <div
                class="mt-1.5 text-lg tracking-wide leading-snug line-clamp-3"
              >
                {{ item.title }}
              </div>
              <div
                class="font-light text-base tracking-wide leading-tight mt-1.5 text-[#D3D3D3] line-clamp-4"
              >
                {{ item.description }}
              </div>
            </div>
            <button class="text-base tracking-wide text-[#286EFF]">
              {{ t('read-more') }}
            </button>
          </div>
        </div>
      </NuxtLink>
    </UCarousel>
  </ClientOnly>
</template>
